module.exports = __webpack_public_path__ + "media/images/salespartner/bg-mv-left_sp-1e9f7949c6f74d25d771d994448fb757.svg";